













import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GExamCreateFormFormat from '../GExamCreateFormFormat.vue';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GVTag from '@/components/GVTag.vue';
import { masterModule } from '@/store/modules/entities/master.module';
import { Language } from '@/models/language';
import { EvalSettingTitleLang } from '@/models/evalSetting/eval-setting-title-lang';

@Component({
  name: 'GExamCreateBaseSettingTitleLanguage',
  components: { GVTag, GExamCreateFormFormat },
  computed: {},
  methods: {},
})
export default class GExamCreateBaseSettingTitleLanguage extends mixins(GPageBase) {
  @Prop() titleLanguage: EvalSettingTitleLang;
  @Prop() index: number;

  mounted() {}

  get isTitleInvalid(): boolean {
    return this.titleLanguage.valid;
  }

  get languages(): Language[] {
    return masterModule.languages;
  }

  get titleLanguages(): EvalSettingTitleLang[] {
    return this.evalSettingDetail.titleLangs;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  handleDelete(index: number) {
    this.titleLanguages.splice(this.index, 1);
  }
}
